import authHeader from "./auth.header"
import constants from './constants.js'
import { apiFetch as fetch } from './api.js'

const HOST_URL = constants.API_URL

export async function fetchIgo(firstElement, lastElement, query) {
    let response
    if (query === '') {
        response = await fetch(HOST_URL + `/igo/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(HOST_URL + `/igo/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }
    const data = await response.json()
    return data
}

export async function fetchAllIgo(query = '') {
    const url = query === ''
        ? `${HOST_URL}/igo/all`
        : `${HOST_URL}/igo/all/${encodeURIComponent(query)}`
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    const data = await response.json()
    return data
}

export async function fetchAllRegions(query = '') {
    const url = query === ''
        ? `${HOST_URL}/country/region/all`
        : `${HOST_URL}/country/region/all/${encodeURIComponent(query)}`
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    const data = await response.json()
    if (!response.ok) {
        const error = new Error(data?.message || data?.error || `Erreur HTTP ${response.status}`)
        error.status = response.status
        throw error
    }
    return data
}

export async function fetchRegionPages(firstElement, lastElement, query = '') {
    const baseUrl = `${HOST_URL}/country/region/pages/${firstElement}/${lastElement}`
    const url = query === '' ? baseUrl : `${baseUrl}/${encodeURIComponent(query)}`
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    const data = await response.json()
    if (!response.ok) {
        const error = new Error(data?.message || data?.error || `Erreur HTTP ${response.status}`)
        error.status = response.status
        throw error
    }
    return data
}

async function postRegion(path, payload) {
    const response = await fetch(`${HOST_URL}/country/region/${path}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(payload)
    })
    const data = await response.json()
    if (!response.ok) {
        const error = new Error(data?.message || data?.error || `Erreur HTTP ${response.status}`)
        error.status = response.status
        throw error
    }
    return data
}

export async function addRegion(region) {
    return postRegion('add', region)
}

export async function updateRegion(region) {
    return postRegion('update', region)
}

export async function deleteRegion(regionId) {
    return postRegion('delete', { id: regionId })
}

export async function fetchIgoById(igoId) {
    const response = await fetch(HOST_URL + '/igo/' + igoId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function updateIgo(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const payload = {
        ...request,
        acronyms: Array.isArray(request?.acronyms)
            ? request.acronyms.map((acronym) => String(acronym).trim()).filter(Boolean)
            : []
    }
    const response = await fetch(HOST_URL + '/igo/edit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(payload)
    })
    const data = await response.json()
    return data
}

export async function deleteIgo(igoId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/delete/' + igoId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function addIgo(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const payload = {
        ...request,
        acronyms: Array.isArray(request?.acronyms)
            ? request.acronyms.map((acronym) => String(acronym).trim()).filter(Boolean)
            : []
    }
    const response = await fetch(HOST_URL + '/igo/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(payload)
    })
    const data = await response.json()
    return data
}

export async function getIgoLogo(igoId) {
    const response = await fetch(HOST_URL + '/igo/logo/' + igoId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function setIgoLogo(igoId, file) {
    const formData = new FormData()
    formData.append('file', file)
    const response = await fetch(HOST_URL + '/igo/logo/' + igoId, {
        method: 'POST',
        headers: {
            ...authHeader()
        },
        body: formData
    })
    if (!response.ok) {
        console.error('Error uploading file:', response.statusText)
        return false
    }
    return true
}


export async function getUserCountry(userId) {
    const response = await fetch(HOST_URL + '/country/user/' + userId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function getIgoByNameAndLanguage(igoName, language, themeId) {
    let response
    if (themeId) {
        response = await fetch(HOST_URL + `/igo/name/${encodeURIComponent(igoName)}/${language}/${themeId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            }
        })
    } else {
        response = await fetch(HOST_URL + `/igo/name/${encodeURIComponent(igoName)}/${language}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            }
        })
    }
    const data = await response.json()
    return data
}

export async function getIgoThemesByNameAndLanguage(igoThemeName, language) {
    const response = await fetch(HOST_URL + `/igo/theme/name/${encodeURIComponent(igoThemeName)}/${language}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function getIgoThemes() {
    const response = await fetch(HOST_URL + '/igo/themes', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function getIgoByThemesId(igoThemeId, firstElement, lastElement) {
    const hasPagination = firstElement !== undefined && lastElement !== undefined
    const endpoint = hasPagination
        ? `/igo/theme/${igoThemeId}/${firstElement}/${lastElement}`
        : '/igo/theme/' + igoThemeId
    const response = await fetch(HOST_URL + endpoint, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function getIgoThemeById(igoId) {
    const response = await fetch(HOST_URL + '/igo/theme/id/' + igoId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function getIgoThemePages(firstElement, lastElement, query) {
    let response;
    if (query === '' || query === null || query === undefined) {
        response = await fetch(HOST_URL + `/igo/theme/pages/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(HOST_URL + `/igo/theme/pages/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }
    const data = await response.json()
    return data
}

export async function createIgoTheme(igoThemeName) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/theme/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ name: igoThemeName })
    })
    const data = await response.json()
    return data
}

export async function deleteIgoTheme(igoThemeId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/theme/delete/' + igoThemeId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function updateIgoTheme(igoThemeId, igoThemeName) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/theme/update', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ id: igoThemeId, name: igoThemeName })
    })
    const data = await response.json()
    return data
}
